
                    import wasm from "../../dist/pkg/web/perspective.cpp.wasm";
                    export default Promise.resolve(wasm);
                